<template>
  <!-- 重写的日期、月份切换组件  
1、事件 leftClick 左边按钮点击数事件监听； rightClick 右边按钮点击事件监听（必填项）； 
2、参数 height 组件卡片高度（必填项）
-->
  <div class="dateChangeCard" :style="`height:${height}`">
    <div class="date_change_btn date_change_btn_l" @click="handleLeft">
      <i class="iconfont icon-arrow-left date_change_icon"></i>
    </div>
    <slot name="main"></slot>
    <div class="date_change_btn date_change_btn_r" @click="handleRight">
      <i class="iconfont icon-arrow-right date_change_icon"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    height: {
      type: String,
      default: "",
    },
  },
  mounted() {},
  methods: {
    handleLeft() {
      this.$emit("leftClick");
    },
    handleRight() {
      this.$emit("rightClick");
    },
  },
};
</script>
<style lang="scss" scoped>
.dateChangeCard {
  position: relative;
}
.date_change_btn {
  cursor: pointer;
  position: absolute;
  // background: rgba(242, 246, 256, 0.5);
  height: 36px;
  width: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 40%;
  z-index: 999;
  .date_change_icon {
    color: rgba(28, 124, 232, 1);
    font-size: 38px;
  }
}
.date_change_btn_l {
  left: 24px;
}
.date_change_btn_r {
  right: 24px;
}
</style>